import React from 'react';
import { FontPicker } from '../../fonts';

export default function InspectorPanel({
  title,
  onTitleChange,
  layers,
  activeLayerId,
  onSelectLayer,
  textStyle,
  onApplyTextStyle,
  opacity,
  onOpacityChange,
  activeObjectType,
  onAddColorLogo,
  onAddWhiteLogo,
  videoSourceUrl,
  onDownloadVideo,
}) {
  return (
    <aside className="manual-inspector" aria-label="Propriedades">
      <div className="manual-inspector__group">
        <h3>Projeto</h3>
        <label className="manual-inspector__label">
          Nome da arte
          <input
            className="manual-inspector__input"
            type="text"
            value={title}
            maxLength={120}
            onChange={(event) => onTitleChange(event.target.value)}
          />
        </label>
      </div>

      <div className="manual-inspector__group">
        <h3>Texto</h3>
        <FontPicker
          label="Fonte"
          value={{ family: textStyle.family, weight: textStyle.weight, preview_url: textStyle.preview_url }}
          onChange={(font) => onApplyTextStyle({ family: font.family, weight: font.weight, preview_url: font.preview_url })}
        />

        <label className="manual-inspector__label">
          Peso
          <input
            className="manual-inspector__input"
            type="number"
            min="100"
            max="900"
            step="100"
            value={textStyle.weight}
            onChange={(event) => onApplyTextStyle({ weight: event.target.value })}
          />
        </label>

        <label className="manual-inspector__label">
          Tamanho
          <input
            className="manual-inspector__input"
            type="number"
            min="8"
            max="280"
            value={textStyle.size}
            onChange={(event) => onApplyTextStyle({ size: Number(event.target.value) })}
          />
        </label>

        <label className="manual-inspector__label">
          Espaçamento
          <input
            className="manual-inspector__input"
            type="number"
            min="-200"
            max="800"
            value={textStyle.spacing}
            onChange={(event) => onApplyTextStyle({ spacing: Number(event.target.value) })}
          />
        </label>
      </div>

      <div className="manual-inspector__group">
        <h3>Elemento</h3>
        <p className="manual-inspector__meta">Selecionado: {activeObjectType || 'nenhum'}</p>
        <label className="manual-inspector__label">
          Opacidade ({opacity}%)
          <input
            className="manual-inspector__range"
            type="range"
            min="0"
            max="100"
            value={opacity}
            onChange={(event) => onOpacityChange(Number(event.target.value))}
          />
        </label>
      </div>

      <div className="manual-inspector__group">
        <h3>Logos</h3>
        <div className="manual-inspector__row">
          <button className="btn btn-secondary" type="button" onClick={onAddColorLogo}>Logo colorida</button>
          <button className="btn btn-secondary" type="button" onClick={onAddWhiteLogo}>Logo branca</button>
        </div>
        {videoSourceUrl && (
          <button className="btn btn-secondary" type="button" onClick={onDownloadVideo}>Baixar vídeo original</button>
        )}
      </div>

      <div className="manual-inspector__group">
        <h3>Camadas</h3>
        <ul className="manual-inspector__layers">
          {layers.map((layer) => (
            <li key={layer.id}>
              <button
                type="button"
                className={layer.id === activeLayerId ? 'is-active' : ''}
                onClick={() => onSelectLayer(layer.id)}
              >
                {layer.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}
